import { useAuth } from "../../Auth/AuthProvider";
import React, { Suspense } from "react";
import { Spinner } from "../LoadingAnimations/LoadingAnimations";
import VisitorsInYard from "./VisitorsInYard";
import ReservationsGraphic from "./ReservationsGraphic";
import Truck34Hour from "../Graphics/Truck34Hour";
import ViewReservations from "./ViewReservations";
import RecentActivityGraphic from "./RecentActivityGraphic";
import { MaintenanceTrucks } from "./MaintenanceTrucks";
import CompletedReports from "./CompletedReports";

const OverviewGraphics = ({truckState}) => {
  const { user } = useAuth();
  const graphics = [
    {
      roles: ["Admin", "Dispatch"],
      graphic: <ReservationsGraphic/>
    },
    {
      roles: ["Maintenance"],
      graphic: <ViewReservations/>
    },
    {
      roles: ["Safety", "Guard"],
      graphic: <RecentActivityGraphic/>
    },
    {
      roles: ["Admin", "Dispatch"],
      graphic: <CompletedReports/>
    },
    {
      roles: ["Admin", "Dispatch"],
      graphic: <Truck34Hour truckState={truckState}/>,
    },
    {
      roles: ["Admin", "Dispatch", "Safety"],
      graphic: <MaintenanceTrucks truckState={truckState}/>,
    },


  ];

  return (
    <div className="graphics-cont">
      {graphics.map((graphic, index) => {
        if (user.groups.some((group) => graphic.roles.includes(group.name))) {
          const GraphicComponent = graphic.graphic;
          return (
            <Suspense key={index} fallback={<Spinner />}>
              {React.cloneElement(GraphicComponent)}
            </Suspense>
          );
        }
      })}
      <VisitorsInYard/>
    </div>
  );
};

export default OverviewGraphics;
